import { post, get, put, deleteM, createApiUrl, instance } from './baseApi';

// 게시판 관련
export function getBoardList(params) {
    const request = createApiUrl("/api/v1/admin/board/list");
    return post(request, params);
}

export function postBoard(notice) {
    const request = createApiUrl("/api/v1/admin/board/post");
    return put(request, notice);
}

export function postBoardReply(articleId, params) {
    const request = createApiUrl("/api/v1/admin/board/" + articleId + "/reply");
    return post(request, params);
}

// 1:1문의 답변 매크로
export function getBoardMacro(params) {
    const request = createApiUrl("/api/v1/admin/board/macro/list");
    return post(request, params);
}

export function saveBoardMacro(params) {
    const request = createApiUrl("/api/v1/admin/board/macro/save");
    return put(request, params);
}

export function deleteBoardMacro(params) {
    const request = createApiUrl("/api/v1/admin/board/macro/delete");
    return put(request, params);
}

// 쪽지 관리
export function sendNote(noteData, headers) {
    const request = "/api/v1/admin/user-notes/send";
    return instance.post(request, noteData, { headers });
}

export function sendBulkNote(noteData, headers) {
    const request = "/api/v1/admin/user-notes/send-bulk";
    return instance.post(request, noteData, { headers });
}

export function getNoteList(companyCode, userId, page, size) {
    const request = createApiUrl("/api/v1/admin/user-notes/list");
    return get(request, {
        companyCode: companyCode,
        userId: userId,
        page: page || 0,
        size: size || 999
    });
}

export function getNoteDetail(seq) {
    const request = createApiUrl("/api/v1/admin/user-notes/" + seq);
    return get(request);
}

export function deleteNote(seq, userId) {
    const request = createApiUrl("/api/v1/admin/user-notes/" + seq);
    return deleteM(request, { userId: userId });
}

// 쿠폰 관리
export function getCouponTemplateList(params) {
    const request = createApiUrl("/api/v1/admin/coupon/templates");
    return get(request, params);
}

export function createCouponTemplate(params) {
    const request = createApiUrl("/api/v1/admin/coupon/templates");
    return post(request, params);
}

export function updateCouponTemplate(templateSeq, params) {
    const request = createApiUrl("/api/v1/admin/coupon/templates/" + templateSeq);
    return put(request, params);
}

export function issueCoupon(params) {
    const request = createApiUrl("/api/v1/admin/coupon/issue");
    return post(request, params);
}

export function getCouponHistory(params) {
    const request = createApiUrl("/api/v1/admin/coupon/history");
    return get(request, params);
}
